<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex class="my-5" xs12></v-flex>
    </v-layout>
    <v-layout text-xs-center wrap>
      <v-flex class="my-5" xs12>
        <v-icon size="128">mdi-wrench</v-icon>
        <h1 class="display-3 font-weight-thin">Developing...</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>
